import { render, staticRenderFns } from "./addHousekeepingFeeType.vue?vue&type=template&id=16a0137a"
import script from "./addHousekeepingFeeType.vue?vue&type=script&lang=js"
export * from "./addHousekeepingFeeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports